module.exports = __webpack_public_path__ + "static/cobra-79ea9e1c296753c3b5a9986c8a93c3f9.jpg";